import { z } from 'zod';

export const getMWAccountGroupsSchema = z.array(
  z.object({
    id: z.string(),
    accountGroup: z.string(),
    mwEntity: z.string(),
  })
);

export type GetMWAccountGroups = z.infer<typeof getMWAccountGroupsSchema>;
